import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  cart: {},
  totalPrice: 0,
  isAddingToCart: {},
  isRemovingFromCart: {},
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  const { isAddingToCart, isRemovingFromCart } = state;

  switch (action.type) {
    case actionTypes.ADD_TO_CART_START:
      return updateObject(state, {
        isAddingToCart: { ...isAddingToCart, [action.id]: true },
      });

    case actionTypes.ADD_TO_CART_FAIL:
      return updateObject(state, {
        error: { _status: true },
        isAddingToCart: { ...isAddingToCart, [action.id]: false },
      });
    case actionTypes.ADD_TO_CART_SUCCESS:
      return updateObject(state, {
        isAddingToCart: { ...isAddingToCart, [action.id]: false },
        totalPrice: action.total,
      });
    case actionTypes.REMOVE_FROM_CART_START:
      return updateObject(state, {
        cart: action.cart,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: true },
      });

    case actionTypes.REMOVE_FROM_CART_FAIL:
      return updateObject(state, {
        error: { _status: true },
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });
    case actionTypes.REMOVE_FROM_CART_SUCCESS:
      return updateObject(state, {
        cart: action.newData,
        totalPrice: action.total,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });

    case actionTypes.UPDATE_CART_START:
      return updateObject(state, {
        cart: action.cart,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: true },
      });

    case actionTypes.UPDATE_CART_FAIL:
      return updateObject(state, {
        error: { _status: true },
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });
    case actionTypes.UPDATE_CART_SUCCESS:
      return updateObject(state, {
        cart: action.newData,
        totalPrice: action.total,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });

    case actionTypes.FETCH_CHECKOUT_SUCCESS:
      return updateObject(state, {
        cart: {},
        totalPrice: 0,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });

    case actionTypes.APPLY_DISCOUNT_CODE_SUCCESS:
      return updateObject(state, {
        cart: action.data,
        totalPrice: action.total,
        isRemovingFromCart: { ...isRemovingFromCart, [action.id]: false },
      });

    case actionTypes.SUBSCRIBE_CART_START:
      return updateObject(state, { loading: true });
    case actionTypes.SUBSCRIBE_CART_FAIL:
      return updateObject(state, { error: { _status: true } });
    case actionTypes.SUBSCRIBE_CART_SUCCESS:
      return updateObject(state, { cart: action.cart, loading: false });
    case actionTypes.UNSUBSCRIBE_CART:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
